<app-ultramarine-layout *ngIf="layout === 'thin'"></app-ultramarine-layout>
